
import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { extractVariables, isValidVariable } from '@/utils/templateUtils';

// Regular expression to match template variables
const VARIABLE_REGEX = /\{\{\s*([a-zA-Z0-9_.]+)\s*\}\}/g;

export const VariableHighlight = Extension.create({
  name: 'variableHighlight',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('variableHighlight'),
        props: {
          decorations: (state) => {
            const { doc } = state;
            const decorations: Decoration[] = [];

            // Process the document and find all template variables
            doc.descendants((node, pos) => {
              if (node.isText) {
                const text = node.text || '';
                let match;
                
                // Reset regex
                VARIABLE_REGEX.lastIndex = 0;
                
                // Find all variables in the text node
                while ((match = VARIABLE_REGEX.exec(text)) !== null) {
                  const start = pos + match.index;
                  const end = start + match[0].length;
                  const variableName = match[1];
                  
                  // Determine if this variable is valid
                  const isValid = isValidVariable(variableName);
                  
                  // Create a decoration for this variable
                  const decoration = Decoration.inline(start, end, {
                    class: isValid 
                      ? 'template-variable template-variable-valid'
                      : 'template-variable template-variable-invalid',
                    'data-variable': variableName
                  });
                  
                  decorations.push(decoration);
                }
              }
              
              return true;
            });

            return DecorationSet.create(doc, decorations);
          },
        },
      }),
    ];
  },
});

export default VariableHighlight;
